
import React from 'react';
import { Col, Row, Carousel } from 'react-bootstrap';
import './Project.css'

const Project = ({ project }) => {

    const { name, key, details, technologies, project_type, live_side, client_side, server_side, image_2, image_3, image_1 } = project;


    return (
        <>
            <div data-aos="zoom-in" className="py-5 border my-4 px-4 single-project">
                <Row>
                    <Col xl={6}>
                        <div className="">
                            <Carousel variant="dark" indicators={false} >
                                <Carousel.Item>
                                    <img
                                        className="d-block w-100"
                                        src={image_1}
                                        alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                        className="d-block w-100"
                                        src={image_2}
                                        alt="Second slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                        className="d-block w-100"
                                        src={image_3}
                                        alt="Third slide"
                                    />
                                </Carousel.Item>
                            </Carousel>
                        </div>
                    </Col>
                    <Col xl={6}>
                        <div className="pt-4">
                            <h4>{name} </h4>
                            <h6>{project_type} </h6>
                            <div className="pt-3">
                                <h4>Overview</h4>
                                <p className="">{details} </p>
                            </div>
                            <h4 className="pt-3">Live Preview</h4>
                            <dev>
                                <a target="_blank" href={live_side}><i class="fas fa-paperclip"></i> Live</a> | <a target="_blank" href={client_side}><i class="fab fa-github"></i> Client</a> | <a target="_blank" href={server_side}><i class="fab fa-github"></i> Server</a>
                            </dev>
                            <h4 className="mt-3">Technologies: <span className="fs-6">{technologies}</span></h4>
                        </div>
                    </Col>
                </Row>
                <div className="project-id text-center">
                    <h5>{key}</h5>
                </div>
            </div>


        </>
    );
};

export default Project;